/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 18.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .factory('ExternalCredentials', function ExternalCredentialsFactory() {
    'use strict';

    function ExternalCredentials(credentials) {
      //// Preconditions
      if (angular.isUndefined(credentials) || !angular.isObject(credentials)) {
        throw Error('Argument error: credentials must be an object');
      }

      //// Transform object from server
      // extend properties to this
      angular.extend(this, credentials);
    }

    //// Public methods
    ExternalCredentials.prototype.isPasswordMasked = function() {
      if (!this.password) {
        return false;
      }

      return this.password.match(/^•+$/);
    };

    //// Public properties
    ExternalCredentials.prototype.id = null;

    ExternalCredentials.prototype.companyId = null;

    ExternalCredentials.prototype.accountId = null;

    ExternalCredentials.prototype.username = null;

    ExternalCredentials.prototype.password = null;

    //// our factory creates a class constructor
    return ExternalCredentials;
  });
